import { mapCommonFile } from './CommonFile.mappers';
import { mapPreviewPictureFromThumbnail } from './picture/BasePicture.mappers';
const hasPreviewableThumbnail = file => {
  var _file$id;
  return (_file$id = file.id) == null ? void 0 : _file$id.endsWith('.riv');
}; // to be changed after proper adaptation on platofmized API

export const mapDocument = (file, baseFile) => ({
  ...mapCommonFile(file, baseFile),
  mediaType: 'document',
  width: null,
  height: null,
  fileOutput: hasPreviewableThumbnail(file) ? mapPreviewPictureFromThumbnail(file) : null
});
export const mapSecureDocument = (file, baseFile) => ({
  ...mapCommonFile(file, baseFile),
  mediaType: 'secure_document',
  width: null,
  height: null
});
//# sourceMappingURL=Document.mappers.js.map